<template>
  <external-links :title="$lang.externalLinksTitle" :sub-title="$lang.externalLinksSubTitle" />
</template>
<script>
export default {
  name: 'About'
}
</script>



// WEBPACK FOOTER //
// src/pages/about.vue